export default __webpack_public_path__ + "static/media/source_fund.c1fd9575.svg";